import { CSPUrlsMap } from '../routes/CSPUrlsMap';

export const HelpCentreTopics = {
  popular: {
    heading: 'Popular questions',
    url: CSPUrlsMap.helpCentrePopular.url,
    icon: 'star',
    subSections: [
      {
        url: CSPUrlsMap.helpCentreClaims.url,
        heading: {
          text: 'Popular in:',
          linkText: 'Claims',
          url: CSPUrlsMap.helpCentreClaims.url,
          linkIcon: 'arrow-right2'
        },
        questionsKey: 'claims',
        maxDisplay: 5
      },

      {
        url: CSPUrlsMap.helpCentrePremiumsPayments.url,
        heading: {
          text: 'Popular in:',
          linkText: 'Premiums & payments',
          url: CSPUrlsMap.helpCentrePremiumsPayments.url,
          linkIcon: 'arrow-right2'
        },
        questionsKey: 'premiums',
        maxDisplay: 5
      },

      {
        url: CSPUrlsMap.helpCentrePolicyCoverage.url,
        heading: {
          text: 'Popular in:',
          linkText: 'Policy coverage',
          url: CSPUrlsMap.helpCentrePolicyCoverage.url,
          linkIcon: 'arrow-right2'
        },
        questionsKey: 'coverage',
        maxDisplay: 5
      }
    ]
  },
  gettingStarted: {
    heading: 'Getting started',
    questionsKey: 'gettingStarted',
    url: CSPUrlsMap.helpCentreGettingStarted.url,
    icon: 'street-signs'
  },
  management: {
    heading: 'Policy management',
    questionsKey: 'management',
    url: CSPUrlsMap.helpCentrePolicyManagement.url,
    icon: 'management'
  },
  claims: {
    heading: 'Claims',
    questionsKey: 'claims',
    url: CSPUrlsMap.helpCentreClaims.url,
    icon: 'paw'
  },
  premiums: {
    heading: 'Premiums & payments',
    questionsKey: 'premiums',
    url: CSPUrlsMap.helpCentrePremiumsPayments.url,
    icon: 'dollar-circle'
  },
  coverage: {
    heading: 'Policy coverage',
    questionsKey: 'coverage',
    url: CSPUrlsMap.helpCentrePolicyCoverage.url,
    icon: 'checklist'
  }
};
